import { render } from "./ProductVariationCreateComponent.vue?vue&type=template&id=21533e3e"
import script from "./ProductVariationCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductVariationCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/variation/ProductVariationCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21533e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21533e3e', __exports__)) {
    api.reload('21533e3e', __exports__)
  }
  
  module.hot.accept("./ProductVariationCreateComponent.vue?vue&type=template&id=21533e3e", () => {
    api.rerender('21533e3e', render)
  })

}


export default __exports__